import { render, staticRenderFns } from "./FaqArea.vue?vue&type=template&id=fd670554&scoped=true&"
import script from "./FaqArea.vue?vue&type=script&lang=js&"
export * from "./FaqArea.vue?vue&type=script&lang=js&"
import style0 from "./FaqArea.vue?vue&type=style&index=0&id=fd670554&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd670554",
  null
  
)

export default component.exports